import { useMutation } from 'platform/useMutation';
import { gql, MutationHookOptions } from '@apollo/client';
import { OdProtosWebData_OccupancyAtVa as OccupancyAtVa } from '__generated__/globalTypes';

export const UpdateOccupancyAtVa = gql`
  mutation UpdateOccupancyAtVa($offerId: String!, $occupancyAtVa: OdProtosWebData_OccupancyAtVa!) {
    sellDirect {
      updateOccupancyAtVa(input: { offerId: $offerId, occupancyAtVa: $occupancyAtVa }) {
        offer {
          id
        }
      }
    }
  }
`;
/**
 * Mutation to update the occupancy at the VA phase.
 *
 * Used for the SSVA Targeting Experiment after the user answers the occupancy question
 * in /sell/virtual-assessment-questions
 */
export const useUpdateOccupancyAtVa = (options?: MutationHookOptions) => {
  const [updateOccupancy, { loading, data, error }] = useMutation(UpdateOccupancyAtVa, {
    onCompleted: options?.onCompleted,
    onError: options?.onError,
    refetchQueries: ['GetSellDirect'],
    awaitRefetchQueries: true,
    errorPolicy: options?.errorPolicy,
  });
  const updateOccupancyAtVa = (offerId: string, occupancyAtVa: OccupancyAtVa) =>
    updateOccupancy({
      variables: { offerId, occupancyAtVa },
    });
  return { updateOccupancyAtVa, loading, data, error };
};
